import React, { useState } from 'react';
import InputMask from 'react-input-mask';
// import { FaTelegram, FaViber } from 'react-icons/fa';
import { BACKEND_URL, COMPANY_PHONES } from '../config';
import '../css/CallbackButton.css';

const CallbackButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [phone, setPhone] = useState('');
    const [status, setStatus] = useState('idle'); // idle | loading | success | error

    const isPhoneValid = phone.replace(/[^\d]/g, '').length === 12 && !phone.includes('_');

    const handleClose = () => {
        setIsOpen(false);
        setStatus('idle');
        setPhone('');
    };

    const handleToggle = () => {
        if (isOpen) {
            handleClose();
        } else {
            setIsOpen(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isPhoneValid) return;

        setStatus('loading');
        try {
            const res = await fetch(`${BACKEND_URL}/callback-requests`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone }),
            });
            if (!res.ok) throw new Error('Server error');
            setStatus('success');
            setTimeout(handleClose, 3000);
        } catch {
            setStatus('error');
        }
    };

    return (
        <div className="callback-wrapper">
            {isOpen && (
                <div className="callback-mobile-overlay" onClick={handleClose} aria-hidden="true" />
            )}
            {isOpen && (
                <div className="callback-popup" role="dialog" aria-label="Замовити зворотній дзвінок">
                    <div className="callback-popup-header">
                        <span className="callback-popup-title">Замовити дзвінок</span>
                        <button
                            className="callback-popup-close"
                            onClick={handleClose}
                            type="button"
                            aria-label="Закрити"
                        >
                            ×
                        </button>
                    </div>

                    {status === 'success' ? (
                        <div className="callback-success">
                            <svg viewBox="0 0 24 24" fill="none" className="callback-success-icon">
                                <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2"/>
                                <path d="M7 12.5l3.5 3.5 6.5-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <p>Дякуємо! Зателефонуємо найближчим часом.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="callback-form" noValidate>
                            <p className="callback-popup-subtitle">Вкажіть ваш номер — ми передзвонимо</p>
                            <InputMask
                                mask="+380 (99) 999-99-99"
                                value={phone}
                                onChange={(e) => {
                                    setPhone(e.target.value);
                                    if (status === 'error') setStatus('idle');
                                }}
                                placeholder="+380 (__) ___-__-__"
                                className="callback-input"
                                type="tel"
                                autoFocus
                            />
                            {status === 'error' && (
                                <p className="callback-error">Помилка. Спробуйте ще раз.</p>
                            )}
                            <button
                                type="submit"
                                className="callback-submit"
                                disabled={!isPhoneValid || status === 'loading'}
                            >
                                {status === 'loading' ? 'Надсилаємо...' : 'Замовити дзвінок'}
                            </button>
                        </form>
                    )}
                </div>
            )}

            {/*
            <div className="callback-messengers">
                <a
                    href={`https://t.me/${COMPANY_PHONES[2].number}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="callback-messenger-btn callback-messenger-btn--telegram"
                    aria-label="Telegram"
                >
                    <FaTelegram />
                </a>
                <a
                    href={`viber://chat?number=%2B${COMPANY_PHONES[2].number.slice(1)}`}
                    className="callback-messenger-btn callback-messenger-btn--viber"
                    aria-label="Viber"
                >
                    <FaViber />
                </a>
            </div>
            */}
            <button
                className={`callback-fab ${isOpen ? 'callback-fab--open' : ''}`}
                onClick={handleToggle}
                type="button"
                aria-label="Замовити зворотній дзвінок"
                aria-expanded={isOpen}
            >
                <svg className="callback-fab-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.47 11.47 0 003.58.57 1 1 0 011 1V21a1 1 0 01-1 1A17 17 0 013 5a1 1 0 011-1h3.5a1 1 0 011 1 11.47 11.47 0 00.57 3.58 1 1 0 01-.24 1.01l-2.21 2.2z"/>
                </svg>
                <span className="callback-fab-label">Замовити дзвінок</span>
            </button>
        </div>
    );
};

export default CallbackButton;
